// import React, { useState, useEffect } from "react";
// import moment from "moment";

// import MaterialTable from "material-table";
// import axios from "axios";
// import urldata from "../../../../urldata";
// import Imageurldata from "../../../../Imageurldata";

// import Button from "../../../../component/Button/Button";
// import { Col, Row, Modal } from "react-bootstrap";
// import InputText from "../../../../component/InputText/InputText";

// import upload from "../../../../images/careers/upload.svg";
// import Toast from "../../../../component/Toast/Toast";
// import close from "../../../../images/close.svg";
// import check from "../../../../images/check.svg";

// const FooterSocialMedia = (props) => {
//     const [loading, setLoading] = useState(false);
//     const [list, setList] = useState([]);
//     const [updateModel, setUpdateModel] = useState(false);

//     const [socialid, setsocialid] = useState("");

//     const [show, setShow] = useState(false);

//     const [sociallink, setsociallink] = useState("");
//     const [sociallinkErr, setsociallinkErr] = useState("");

//     const [bannerImg, setBannerImg] = useState("");
//     const [bannerImgErr, setBannerImgErr] = useState("");

//     const [imgNotPresent, setImgNotPresent] = useState('')

//     const [showImg, setShowImg] = useState('')

//     const [toastlist, setToastList] = useState([]);

//     let toastProperties = null;

//     useEffect(() => {
//       let url = new URL(urldata + "admin/getsocial");
//       setLoading(true);
//       axios({
//         method: "get",
//         url: url,
//         withCredentials: true,
//       })
//         .then((response) => {
//           const templist = response.data.data.reverse();
//           setList(templist);
//           setLoading(false);
//         })
//         .catch((error) => {
//           setLoading(false);
//         });
//     }, []);

//     const showToast = (type) => {
//       const id = Math.floor(Math.random() * 101 + 1);
//       switch (type) {
//         case "success":
//           toastProperties = {
//             id,
//             title: "Success",
//             description: `Social Media data ${updateModel? 'updated': 'saved'} Successfully`,
//             backgroundColor: "#329F33",
//             icon: check,
//           };
//           break;
//         case "danger":
//           toastProperties = {
//             id,
//             title: "Something Went Wrong",
//             description: "",
//             backgroundColor: "red",
//             icon: close,
//           };
//           break;
//         case "delete":
//           toastProperties = {
//             id,
//             title: "Success",
//             description: "Social Media data deleted Successfully",
//             backgroundColor: "#329F33",
//             icon: check,
//           };
//           break;

//         default:
//           setToastList([]);
//       }

//       setToastList([...toastlist, toastProperties]);
//     };

//     const handleClose = () => setShow(false);
//     const handleShow = () => {
//       setShowImg(false)
//       setBannerImg("");

//       setUpdateModel(false);
//       setsociallink("");

//       setShow(true);
//     };

//     const handleShowForUpdate = (rowData) => {
//       setShow(true);
//       setUpdateModel(true);
//       setBannerImg(Imageurldata+rowData.imgUrl);
//       setShowImg(false);
//       setsociallink(rowData.sociallink);
//       setsocialid(rowData._id);
//       setImgNotPresent(rowData.imgUrl ? false: true)

//     };

//     const updateTvAd = () => {
//       let formData = new FormData();
//       formData.append("sociallink", sociallink);

//       if(imgNotPresent){
//         formData.append("banner", bannerImg);
//         setImgNotPresent(false)
//       }

//       let url = new URL(urldata + "admin/updatesocial");

//       url.searchParams.append("id", socialid);
//       var decoded = decodeURIComponent(url);

//       setLoading(true);
//       axios({
//         method: "post",
//         url: decoded,
//         data: formData,
//         withCredentials: true,
//       })
//         .then((response) => {
//           const templist = response.data.data.reverse();
//           setList(templist);
//           setShow(false);
//           setLoading(false);
//           showToast("success");

//         })
//         .catch((error) => {
//           setLoading(false);
//         });
//     };

//     const addTvAd = () => {
//       let formData = new FormData();
//       formData.append("sociallink", sociallink);
//       formData.append("banner", bannerImg);

//       let url = new URL(urldata + "admin/addsocial");

//       setLoading(true);
//       axios({
//         method: "post",
//         url: url,
//         data: formData,
//         withCredentials: true,
//       })
//         .then((response) => {
//           const tempList = response.data.data.reverse();
//           setList(tempList);
//           setShow(false);
//           setLoading(false);
//           showToast('success')
//         })
//         .catch((error) => {
//           setLoading(false);
//         });
//     };

//     const submit = () => {
//       let formIsValid = true;

//       if (!sociallink) {
//         formIsValid = false;
//         setsociallinkErr("*Please add social media link");
//       } else {
//         setsociallinkErr("");
//       }

//       if (!bannerImg) {
//         formIsValid = false;
//         setBannerImgErr("*Please social media image");
//       } else {
//         setBannerImgErr("");
//       }

//       if (formIsValid) {
//         if (updateModel) {
//           updateTvAd();
//         } else {
//           addTvAd();
//         }
//       }
//     };

//     const deleteBtnClick = (id) => {
//     //   let data = {};
//     //   data.id = id;

//       let url = new URL(urldata + "admin/deletesocial");

//       url.searchParams.append("id", id);
//       var decoded = decodeURIComponent(url);

//       setLoading(true);
//       axios({
//         method: "post",
//         url: decoded,
//         // data: data,
//         withCredentials: true,
//       })
//         .then((response) => {
//           const templist = response.data.data.reverse();
//           setList(templist);
//           setLoading(false);
//           showToast("delete");
//         })
//         .catch((error) => {
//           // showToast("danger");
//           console.error(error);
//           setLoading(false);
//         });
//     };

//     if (loading) {
//       return (
//         <div id="wrapper">
//           <div className="profile-main-loader">
//             <div className="loader">
//               <svg className="circular-loader" viewBox="25 25 50 50">
//                 <circle
//                   className="loader-path"
//                   cx="50"
//                   cy="50"
//                   r="20"
//                   fill="none"
//                   stroke="#ed1c24"
//                   strokeWidth="2"
//                 />
//               </svg>
//             </div>
//           </div>
//         </div>
//       );
//     }

//     return (
//       <>
//         <div className="addjobinlist text-right mb-4">
//           <Button title="Add Social Media" onClick={handleShow} />
//         </div>
//         <MaterialTable
//           title="Social Media list"
//           columns={[
//             { title: "Social Link", field: "sociallink" },
//             {
//               field: "imgUrl",
//               title: "Social Media Image",
//               render: (rowData) => (
//                 <div className="d-f">
//                   <Button
//                     title="View"
//                     onClick={() => {
//                       window.open(Imageurldata + rowData.imgUrl, "_blank");
//                     }}
//                   ></Button>
//                 </div>
//               ),
//             },
//             {
//               field: "url",
//               title: "Action",
//               render: (rowData) => (
//                 <div className="d-f">
//                   <Button
//                     title=" Update"
//                     onClick={() => {
//                       handleShowForUpdate(rowData);
//                     }}
//                   ></Button>
//                   <Button
//                     title=" Delete"
//                     onClick={() => deleteBtnClick(rowData._id)}
//                   ></Button>
//                 </div>
//               ),
//             },
//           ]}
//           data={list}
//           options={{
//             exportButton: true,
//             actionsColumnIndex: -1,
//           }}
//         />

//         <Modal
//           {...props}
//           dialogClassName="addbannerModel"
//           centered
//           show={show}
//           onHide={handleClose}
//         >
//           <Modal.Header closeButton></Modal.Header>
//           <Modal.Body className="model" style={{ position: "relative" }}>
//             <div className="title">
//               {updateModel ? "Update Social Media" : "Add Social Media"}
//             </div>

//             <Row>
//               {/* col 1 */}
//               <Col lg={3} className="column">
//                 <div className="titleitem">Social Media Link</div>
//               </Col>
//               <Col lg={9} className="column">
//                 <input
//                   value={sociallink}
//                   onChange={(e) => setsociallink(e.target.value)}
//                   type="text"
//                 />
//                 <div className="err">{sociallinkErr}</div>
//               </Col>

//               {/* col-4 */}
//               <Col lg={3} className="column">
//                 <div className="titleitem">Social Media Image</div>
//                 <div className="desc">Size :- 42 × 30</div>
//               </Col>
//               <Col lg={9} className="column">
//                 <input
//                   id="bannerImage"
//                   accept="image/jpg ,image/png, image/JPG ,image/PNG, image/jpeg, image/JPEG,  image/svg, image/SVG"
//                   type="file"
//                   onChange={(e) => {
//                     setBannerImg(e.target.files[0]);
//                     setShowImg(true);
//                     setImgNotPresent(true);
//                   }}
//                   name="passport_proof_upload"
//                 />

//                 <label htmlFor="bannerImage" className="d-f" id="file-drag">
//                   <img src={upload} className="img-fluid" />
//                   <div className="chooseTxt">Choose File</div>
//                 </label>

//                 <div className="d-f jc-sb">
//                   <div className="fileTxt">File Format : JPG / png</div>
//                   <div className="fileTxt text-primary">
//                     {bannerImg ? bannerImg.name : ""}
//                   </div>
//                 </div>
//                 <div className="err">{bannerImgErr} </div>
//               </Col>
//             </Row>

//             <div className="btnContainer btn_press mt-4">
//               <Button onClick={submit} title="SUBMIT" />
//             </div>
//             <div className="text-right">
//               {bannerImg !== "" && (
//                 <img
//                   src={showImg ? URL.createObjectURL(bannerImg) : bannerImg}
//                   alt=""
//                   style={{ width: "100px", height: "100px", backgroundColor: 'gray' }}
//                 />
//               )}
//             </div>
//           </Modal.Body>
//         </Modal>
//         <Toast toastList={toastlist} position="top-right" />
//       </>
//     );
// }

// export default FooterSocialMedia

// by jayesh
import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";
import axios from "axios";
import config from "../../../../config/config";
import Imageurldata from "../../../../Imageurldata";

import Button from "../../../../component/Button/Button";
import { Row, Col, Modal } from "react-bootstrap";
import Toast from "../../../../component/Toast/Toast";
import upload from "../../../../images/careers/upload.svg";
import check from "../../../../images/check.svg";
import close from "../../../../images/close.svg";
import { Switch, Space } from "antd";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Modal as AntModal, List } from "antd";
import { DragHandle } from "../../../../components/DragHandle";

const FooterSocialMedia = () => {
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);

  const [show, setShow] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);

  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [link, setLink] = useState("");
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState("");

  const [nameErr, setNameErr] = useState("");
  const [linkErr, setLinkErr] = useState("");
  const [imageErr, setImageErr] = useState("");

  const [toastlist, setToastList] = useState([]);

  const [orderingOpen, setOrderingOpen] = useState(false);
  const [orderingList, setOrderingList] = useState([]);
  const [orderingLoading, setOrderingLoading] = useState(false);

  // Load all social media items
  const loadData = () => {
    setLoading(true);
    axios
      .get(`${config.api_url}footer/social`)
      .then((res) => {
        setList(res.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    loadData();
  }, []);

  // Toast helper
  const showToast = (type, message) => {
    const id = Math.floor(Math.random() * 1000 + 1);
    const toastProperties = {
      id,
      title: type === "success" ? "Success" : "Error",
      description: message,
      backgroundColor: type === "success" ? "#329F33" : "red",
      icon: type === "success" ? check : close,
    };
    setToastList([...toastlist, toastProperties]);
  };

  // Open Add Modal
  const openAddModal = () => {
    setIsUpdate(false);
    setId("");
    setName("");
    setLink("");
    setImage(null);
    setPreview("");
    setShow(true);
  };

  // Open Edit Modal
  const openEditModal = (row) => {
    setIsUpdate(true);
    setId(row._id);
    setName(row.name);
    setLink(row.link);
    setPreview(Imageurldata + row.icon);
    setImage(null); // only change image if user uploads new
    setShow(true);
  };

  // Submit add/update
  const submit = () => {
    let valid = true;

    if (!name) {
      setNameErr("*Enter name");
      valid = false;
    } else setNameErr("");

    if (!link) {
      setLinkErr("*Enter link");
      valid = false;
    } else setLinkErr("");

    if (!isUpdate && !image) {
      setImageErr("*Upload icon image");
      valid = false;
    } else setImageErr("");

    if (!valid) return;

    const formData = new FormData();
    formData.append("name", name);
    formData.append("link", link);

    if (image) formData.append("icon", image);

    if (isUpdate) formData.append("id", id);

    setLoading(true);

    const url = isUpdate
      ? `${config.api_url}footer/social/update`
      : `${config.api_url}footer/social/new`;

    axios
      .post(url, formData)
      .then(() => {
        loadData();
        setShow(false);
        showToast(
          "success",
          isUpdate ? "Updated successfully" : "Social media added successfully",
        );
      })
      .catch((err) => {
        const msg = err?.response?.data?.error || "Something went wrong";
        showToast("error", msg);
      })
      .finally(() => setLoading(false));
  };

  // Delete item
  const deleteItem = (id) => {
    setLoading(true);
    axios
      .post(`${config.api_url}footer/social/delete`, { id })
      .then(() => {
        loadData();
        showToast("success", "Deleted successfully");
      })
      .catch(() => showToast("error", "Failed to delete"))
      .finally(() => setLoading(false));
  };

  // Toggle status
  const toggleStatus = (id) => {
    setLoading(true);
    axios
      .post(`${config.api_url}footer/social/status`, { id })
      .then(() => {
        // update UI without reloading list
        setList((prev) =>
          prev.map((item) =>
            item._id === id ? { ...item, status: !item.status } : item,
          ),
        );

        showToast("success", "Status updated");
      })
      .catch(() => showToast("error", "Failed to toggle"))
      .finally(() => setLoading(false));
  };

  const openOrderingModal = () => {
    setOrderingList(list); // use current list
    setOrderingOpen(true);
  };

  const onSocialDragEnd = (result) => {
    if (!result.destination) return;

    const srcIndex = result.source.index;
    const destIndex = result.destination.index;

    const temp = Array.from(orderingList);
    const [moved] = temp.splice(srcIndex, 1);
    temp.splice(destIndex, 0, moved);

    setOrderingList(temp);
  };

  const handleSocialOrderSave = async () => {
    try {
      setOrderingLoading(true);

      const orderedIds = orderingList.map((item) => item._id.toString());

      await axios.post(`${config.api_url}footer/social/reorder`, {
        orderedIds,
      });

      showToast("success", "Order updated successfully");

      setOrderingOpen(false);
      loadData(); // reload sorted list
    } catch (err) {
      showToast("error", "Failed to update order");
    } finally {
      setOrderingLoading(false);
    }
  };

  if (loading) {
    return (
      <div id="wrapper">
        <div className="profile-main-loader">
          <div className="loader">
            <svg className="circular-loader" viewBox="25 25 50 50">
              <circle
                className="loader-path"
                cx="50"
                cy="50"
                r="20"
                fill="none"
                stroke="#ed1c24"
                strokeWidth="2"
              />
            </svg>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Add button */}
      <div
        className="addjobinlist text-right mb-4"
        style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}
      >
        <Button title="Reorder Social Media" onClick={openOrderingModal} />
        <Button title="Add Social Media" onClick={openAddModal} />
      </div>

      {/* Table */}
      <MaterialTable
        title="Social Media links "
        columns={[
          { title: "Name", field: "name" },
          { title: "Link", field: "link" },
          {
            title: "Status",
            render: (rowData) => (
              <Space size="middle">
                <Switch
                  checkedChildren="On"
                  unCheckedChildren="Off"
                  checked={rowData.status}
                  onChange={() => toggleStatus(rowData._id)}
                  style={{ backgroundColor: rowData.status ? "red" : "#ccc" }}
                />
              </Space>
            ),
          },
          {
            title: "Icon",
            render: (rowData) => (
              <Button
                title="View"
                onClick={() =>
                  window.open(Imageurldata + rowData.icon, "_blank")
                }
              />
            ),
          },
          {
            title: "Action",
            render: (rowData) => (
              <div style={{ display: "flex", gap: "0px" }}>
                <Button title="Update" onClick={() => openEditModal(rowData)} />
                <Button
                  title="Delete"
                  onClick={() => deleteItem(rowData._id)}
                />
              </div>
            ),
          },
        ]}
        data={list}
        options={{
          search: false,
          exportButton: false,
          actionsColumnIndex: -1,
        }}
      />

      {/* Modal */}
      <Modal
        centered
        show={show}
        onHide={() => setShow(false)}
        dialogClassName="addbannerModel"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="model">
          <div className="title">
            {isUpdate ? "Update Social Media" : "Add Social Media"}
          </div>

          <Row>
            {/* Name */}
            <Col lg={3} className="column">
              <div className="titleitem">Name</div>
            </Col>
            <Col lg={9} className="column">
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="form-control"
                placeholder="Enter social media name"
              />
              <div className="err">{nameErr}</div>
            </Col>

            {/* Link */}
            <Col lg={3} className="column">
              <div className="titleitem">Link</div>
            </Col>
            <Col lg={9} className="column">
              <input
                type="text"
                value={link}
                onChange={(e) => setLink(e.target.value)}
                className="form-control"
                placeholder="https://www.youtube.com/ "
              />
              <div className="err">{linkErr}</div>
            </Col>

            {/* Icon */}
            <Col lg={3} className="column">
              <div className="titleitem">Icon</div>
              <div className="desc">Size: 82 × 82</div>
              <div className="desc">SVG format supported</div>
            </Col>
            <Col lg={9} className="column">
              <input
                id="iconUpload"
                type="file"
                accept="image/*"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (!file) return;

                  const validTypes = [
                    "image/png",
                    "image/jpeg",
                    "image/jpg",
                    "image/webp",
                    "image/gif",
                    "image/svg+xml", // <-- added SVG
                  ];

                  if (!validTypes.includes(file.type)) {
                    setImageErr(
                      "Only image files allowed (PNG, JPG, JPEG, WEBP, GIF, SVG)",
                    );
                    setImage(null);
                    setPreview("");
                    e.target.value = "";
                    return;
                  }

                  setImageErr("");
                  setImage(file);
                  setPreview(URL.createObjectURL(file));
                }}
                className="form-control-file"
              />

              <label htmlFor="iconUpload" className="d-f mt-2" id="file-drag">
                <img src={upload} className="img-fluid" />
                <div className="chooseTxt">Choose File</div>
              </label>

              {/* <div className="d-f jc-sb">
                <div className="fileTxt">File Format : JPG / png / Svg</div>
              </div> */}

              <div className="fileTxt text-primary mt-1">
                {image ? image.name : ""}
              </div>
              <div className="err">{imageErr}</div>

              {preview && (
                <img
                  src={preview}
                  alt="preview"
                  style={{
                    width: "100px",
                    height: "100px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    marginTop: "10px",
                    objectFit: "cover",
                  }}
                />
              )}
            </Col>
          </Row>

          {/* Submit Button Centered */}
          <div className="btnContainer mt-4 d-flex justify-content-center">
            <Button
              title="SUBMIT"
              onClick={submit}
              style={{ minWidth: "120px" }}
            />
          </div>
        </Modal.Body>
      </Modal>

      <AntModal
        title="Reorder Social Media"
        visible={orderingOpen}
        onOk={handleSocialOrderSave}
        okText="Update Order"
        confirmLoading={orderingLoading}
        onCancel={() => setOrderingOpen(false)}
      >
        <DragDropContext onDragEnd={onSocialDragEnd}>
          <Droppable droppableId="social-ordering">
            {(provided) => (
              <div
                ref={provided.innerRef}
                {...provided.droppableProps}
                style={{ maxHeight: 400, overflowY: "auto" }}
              >
                {orderingList.map((item, index) => (
                  <Draggable
                    key={item._id.toString()}
                    draggableId={item._id.toString()}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        style={{
                          ...provided.draggableProps.style,
                          padding: "10px",
                          marginBottom: "8px",
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                          background: "#fff",
                          boxShadow: snapshot.isDragging
                            ? "0 0 .4rem #666"
                            : "none",
                        }}
                      >
                        {/* Name Column */}
                        <div
                          style={{
                            flex: 1,
                            fontWeight: 500,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          title={item.name}
                        >
                          {item.name}
                        </div>

                        {/* Link Column */}
                        <div
                          style={{
                            flex: 2,
                            color: "#666",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          title={item.link}
                        >
                          {item.link}
                        </div>

                        {/* Drag Handle */}
                        <div
                          {...provided.dragHandleProps}
                          style={{
                            cursor: "grab",
                            fontSize: 18,
                            padding: "0 6px",
                          }}
                        >
                          ☰
                        </div>
                      </div>
                    )}
                  </Draggable>
                ))}

                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </AntModal>

      <Toast toastList={toastlist} position="top-right" />
    </>
  );
};

export default FooterSocialMedia;
